import styled from 'styled-components';

const StyledExpenseDetailsPanel = styled.div`
  width: 100%;
  position: relative;

  .ant-tabs-content-holder {
    .ant-tabs-content {
      transition: .1s ease-in-out;
    }
  }
`;


export {
  StyledExpenseDetailsPanel,
}
